import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import type { SurveyListItem } from 'src/types/survey';
import { apiPaths } from 'src/services/api/apiPaths';
import HttpService from 'src/services/api/http';
import { useUserContext } from 'src/components/app/context/UserContext';

const fetchSurveyList = (endpoint: string) =>
  HttpService.get(endpoint)
    .then(({ data }: AxiosResponse<SurveyListItem[]>) => Promise.resolve(data))
    .catch(({ response }) => Promise.reject(response.status));

const useFetchSurveyList = (enabled = true) => {
  const endpoint = apiPaths.SURVEY.LIST;
  const { user } = useUserContext();
  return useQuery<SurveyListItem[]>({
    queryKey: [endpoint, user],
    queryFn: () => fetchSurveyList(endpoint),
    enabled: !!user && enabled,
  });
};

export default useFetchSurveyList;
